export enum SpecialLeaveWeekEnums {
  ALL_DAYS = 'ALL_DAYS',
  WORKING_DAYS = 'WORKING_DAYS'
}
